import * as ReactDOM from "react-dom";

export function createRoot(container) {
  return {
    render: (el) => {
      ReactDOM.render(el, container);
    },
    unmount: () => ReactDOM.unmountComponentAtNode(container),
  };
}

export function hydrateRoot(container, el) {
  ReactDOM.hydrate(el, container);
  return {
    render: () => {},
    unmount: () => ReactDOM.unmountComponentAtNode(container),
  };
}
